const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/fields/YesNoField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import { MessageDescriptor } from '@formatjs/intl';
import { getYesNoOptions } from '@cistec/common_web/modules/CIS4m/utils/form';
import { CIS4mRadioButtonGroup } from '@cistec/common_web/modules/CIS4m/components/CIS4mRadioButtonGroup';

interface Props {
    label?: string | MessageDescriptor;
    infoText?: string | MessageDescriptor;
    path: string;
    hidden?: boolean;
    required?: boolean;
    yesValue?: string;
    noValue?: string;
}

export const YesNoField = forwardRef((props: Props, ref: any) => {
    const { formatMessage } = useIntl();

    const radioButtonRef = useCIS4m(ref);

    const label = !props.label || typeof props.label === 'string' ? props.label : formatMessage(props.label);
    const infoText =
        !props.infoText || typeof props.infoText === 'string' ? props.infoText : formatMessage(props.infoText);
    const hidden = props.hidden ?? false;
    const required = props.required ?? false;

    const yes = props.yesValue ?? '1';
    const no = props.noValue ?? '0';

    const yesNoOptions = getYesNoOptions(formatMessage, yes, no);

    return (
        <CIS4mRadioButtonGroup
            ref={radioButtonRef}
            label={label}
            infoText={infoText}
            path={props.path}
            options={yesNoOptions}
            storeValueAsObject={false}
            hidden={hidden}
            required={required}
        />
    );
});

YesNoField.displayName = 'YesNoField';
